<template>
    <div class="box milestone">
        <div class="columns">
            <div class="column">
                <b>{{milestone.name}}</b>
                <p class="has-text-grey">{{milestone.description}}</p>
            </div>

            <div class="column is-narrow buttons">
                <base-button
                    @click="toggle"
                    :loading="loading"
                    :text="milestone.is_open ? 'Close milestone' : 'Reopen milestone'"
                    :class="{'is-danger': milestone.is_open}"
                    class="is-outlined"/>

                <base-button
                    @click="show_edit = true"
                    icon="fas fa-pen"
                    class="is-outlined"/>

                <base-button
                    @click="show_confirm = true"
                    icon="fas fa-trash-alt"
                    class="is-outlined"/>
            </div>
        </div>

        <milestone-update-modal
            v-if="show_edit"
            :space="space"
            :milestone="milestone"
            @close="show_edit = false"/>

        <base-confirm-modal
            v-if="show_confirm"
            text="Do you really want to remove this Milestone?"
            :loading="remove.loading"
            @close="show_confirm = false"
            @ok="remove_milestone"/>
    </div>
</template>

<script>
import { mapState } from 'vuex';
import MilestoneUpdateModal from './MilestoneUpdateModal.vue';

export default {
    name: 'MilestonesListItem',
    components: { MilestoneUpdateModal },
    props: ['space', 'milestone'],
    computed: mapState('milestones', ['remove']),
    data() {
        return { loading: false, show_edit: false, show_confirm: false };
    },
    methods: {
        async toggle() {
            this.loading = true;
            await this.$store.dispatch('milestones/update', {
                space_id: this.space.id,
                milestone_id: this.milestone.id,
                data: { is_open: !this.milestone.is_open },
            });

            this.loading = false;
            this.$store.commit('milestones/toggle_milestone', this.milestone.id);
        },
        async remove_milestone() {
            await this.$store.dispatch('milestones/remove', {
                milestone_id: this.milestone.id,
                space_id: this.space.id,
            });

            this.show_confirm = false;

            this.$store.dispatch('milestones/list', {
                page: this.$route.query.page || 1,
                space_id: this.space.id,
            });
        },
    },
};
</script>

<style scoped>

</style>
